export default __webpack_public_path__ + "static/media/jeremy-card.e9122452.svg";